import React from 'react';
import { cn } from '@skin-seoul/design-system';
import ProductImage from '../components/ProductImage';
import { Condition } from '../../../utils/react/Condition';
import { useProductCard } from '../ProductCardContext';
import { isNil } from 'es-toolkit';
import { DiscountBadge } from '../components/DiscountBadge';
import { CreditSealBadge } from '../components/CreditSealBadge';
import {
  CREDIT_SEAL_BADGE_INSET_PX,
  CREDIT_SEAL_BADGE_Z_INDEX,
} from '../components/creditSealBadgeVariants';

type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
  className?: string;
};

export const HorizontalProductCardImage = ({ topSlot, bottomSlot, className }: ProductCardImageProps) => {
  const { ranking } = useProductCard();
  return (
    <div
      className={cn(
        'relative bg-neutral-50 w-[132px] h-full p-4 min-w-[132px] items-center self-stretch rounded-[8px] box-border',
        className,
      )}
    >
      <div className="absolute z-[2] top-0 left-0 w-full flex">
        <>{topSlot}</>
      </div>
      <DiscountBadge />
      {/* Seal takes the top-right so it never collides with the top-left discount badge. */}
      {/* Seal takes the top-right so it never collides with the top-left discount badge. */}
      <CreditSealBadge
        variant="s"
        className="absolute"
        style={{
          top: CREDIT_SEAL_BADGE_INSET_PX.cardHorizontal,
          right: CREDIT_SEAL_BADGE_INSET_PX.cardHorizontal,
          zIndex: CREDIT_SEAL_BADGE_Z_INDEX,
        }}
      />
      <ProductImage />
      <Condition
        expression={!isNil(ranking)}
        then={
          <div className="absolute bottom-0 left-0 h-12 w-12 flex items-center justify-center">
            <p className="text-neutral-200 text-heading-h2">{ranking}</p>
          </div>
        }
      />
      <div className="absolute bottom-0 z-[2] left-0 w-full flex">
        <>{bottomSlot}</>
      </div>
    </div>
  );
};
